<template>
  <svg
    height="40"
    width="40"
    viewBox="0 0 180 180"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Lawdex Sign"
  >
    <rect
      x="4"
      y="4"
      width="172"
      height="172"
      rx="26"
      fill="#33040E"
    />
    <path
      d="M46 37h60v17H94v72h31v-22h18v39H46v-17h14V54H46V37Z"
      fill="#FFFFFF"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
